module.exports = __webpack_public_path__ + "static/img/unit3.25a022b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unit3.png
// module id = f1ni
// module chunks = 1